// extracted by mini-css-extract-plugin
export var adCard = "_os-8";
export var adCardBorder = "_os-5";
export var arbiterButtonIcon = "_os-p";
export var buttonIcon = "_os-o";
export var container = "_os-e";
export var copyButton = "_os-m";
export var darkGrey = "_os-u";
export var deliveryDate = "_os-2";
export var divider = "_os-n";
export var editModeWrapper = "_os-7";
export var empty = "_os-a";
export var errorIcon = "_os-d";
export var filledCircle = "_os-4";
export var fulfillmentFooter = "_os-j";
export var grey = "_os-s";
export var header = "_os-i";
export var headerWrapper = "_os-h";
export var highlighted = "_os-6";
export var historyEntry = "_os-3";
export var mobileColumn = "_os-v";
export var mobileColumnReverse = "_os-w";
export var orderDetailsContainer = "_os-g";
export var orderMetadata = "_os-l";
export var orderMetadataWrapper = "_os-k";
export var packagesContainer = "_os-b";
export var product = "_os-y";
export var productImage = "_os-z";
export var productInfo = "_os-x";
export var productTitle = "_os-10";
export var strikethrough = "_os-t";
export var tinyText = "_os-r";
export var title = "_os-9";
export var trackerCard = "_os-1";
export var trackerCardWrapper = "_os-0";
export var trackingContainer = "_os-f";
export var trackingTitle = "_os-c";
export var xTinyText = "_os-q";